module.exports = __webpack_public_path__ + "img/img7610.6a34d084.jpg";